import ImageGallery from '../../component/ImageGallery';
import Project from '../../component/Project';
import worldTradeCentreData from '../../data/AhliBankHead.json';
const AhliBankHead = () => {
  const { pageData, containerData, content, images, styles } = worldTradeCentreData;
  return (<>
      <Project pageData={pageData} containerData={containerData} content={content} images={images} styles={styles} />
      </>
 )
}

export default AhliBankHead
